module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Left_nav_set"
  }, [_vm._l((_vm.routes), function(item) {
    return [_vm._l((item.children), function(child, inx) {
      return (!item.hidden && item.noDropdown && item.children.length > 0) ? [(child.parent) ? [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
        attrs: {
          "to": {
            path: item.path + '/' + child.path,
            query: child.params,
          }
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(item.icon) ? _c('i', {
        class: item.icon
      }) : _vm._e(), _vm._v("\n          " + _vm._s(child.name) + "\n        ")])], 1) : _vm._e()] : _vm._e()] : _vm._e()
    }), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.key
      }
    }, [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n      ")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": {
            path: item.path + '/' + child.path,
            query: child.params
          }
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n              " + _vm._s(child.name) + "\n            ")])], 1)] : _vm._e()] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-0ead5659"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 1414
// module chunks = 1